/* global __DEV__ */
import uuidv4 from 'uuid/v4';
import { fetch as unFetch } from '@binance/fetch';
import bridge from '../bridge';

import { eraseCookie } from '../../utils/cookies-browser';
import bog from '../../utils/moreBog';
import { getUrl } from '../../utils/makeApiRequest';

const DEFAULT_TIMEOUT = __DEV__ ? 20000 : 2000;
const SLOW_API_THRESHOLD_MS = 350;

const fetch = typeof window === 'undefined' ? unFetch : async (url, opts) => bridge.fetch(url, opts);

export class NotLoggedInError extends Error {
  constructor(message, name, httpStatus) {
    super();
    this.message = message || 'Not logged in';
    this.name = name || 'Error';
    this.httpStatue = httpStatus || 401;
  }
}

const effectRequest = async (url, opts) => {
  const startTime = Date.now();
  const res = await fetch(url, opts);
  const endTime = Date.now();
  const duration = endTime - startTime;
  if (duration >= SLOW_API_THRESHOLD_MS) {
    bog.warn('Slow API call found!', `${parseInt(duration, 10)}ms`, url);
  }
  bog.debug(`res: ${JSON.stringify(res)}`);
  return res;
};

const handleStatusError = async (res, req, url) => {
  const { status } = res;
  if (status === 401) {
    if (!req) {
      eraseCookie('cr00');
      eraseCookie('logined');
    }
    throw new NotLoggedInError();
  } else if (status === 413) {
    throw res;
  } else if (status === 400) {
    throw res;
  } else if (status < 200 || status >= 300) {
    let msg = `HTTP status code ${res.status}${__DEV__ || req ? `: ${url}` : ''}`;
    try {
      const data = await res.json();
      const { msg: _msg } = data;
      if (_msg) msg = _msg;
      bog.error('API Error got from server', msg);
    } catch (_err) {
      // noop
    }
    throw new Error(status);
  }
  return null;
};

export const requestApi = async (apiPath, optData, req) => {
  const url = getUrl(req, apiPath);
  const uuid = uuidv4();
  const opts = {
    ...optData,
    headers: {
      ...(optData ? optData.headers : {}),
      'X-UI-REQUEST-TRACE': uuid,
    },
    timeout: DEFAULT_TIMEOUT,
  };
  try {
    const res = await effectRequest(url, opts);
    await handleStatusError(res, req, url);
    const middle = await res.text();
    return middle ? JSON.parse(middle) : middle;
  } catch (err) {
    throw err;
  }
};
